// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UngroupOutlinedSvg from "@fishx/icons-svg/es/asn/UngroupOutlined";
import FishxIcon from '../components/FishxIcon';

var UngroupOutlined = function UngroupOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UngroupOutlinedSvg
  }));
};

UngroupOutlined.displayName = 'UngroupOutlined';
export default React.forwardRef(UngroupOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UngroupOutlined.js
// module id = 4310
// module chunks = 0